
















import { Component, Inject, Vue } from 'vue-property-decorator'
import { getSelectedCityId } from '@utils/index'
import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')
// import defaultAvatar from '../../assets/image/IMG_7215@3x.png'

interface IshopDetail {
  storeImg: string
  storeHeadImg: string
  storeName: string
  storeCategory: string
  distance: string
  distanceKm: string
  mobile: string | number
}

@Component({
  components: {},
})
export default class Description2 extends Vue {
  @Inject({ default: null })
  telTrackParams!: any
  
  @shopHomeModule.State shopDetail!: IshopDetail
  @shopHomeModule.State serviceDetail!: any

  get showStoreHeadImg() {
    return this.shopDetail ? this.shopDetail.storeHeadImg || this.shopDetail.storeImg || require('@assets/images/icon_default_store_head_img.png') : ''
  }

  get showStoreName() {
    return this.shopDetail && this.shopDetail.storeName/*  && this.shopDetail.storeName.slice(0, 80) */
  }

  makeTel() {
    window.location.href = `tel:${this.shopDetail && this.shopDetail.mobile}`
    this.telTrackParams && this.$newClickTracker(this.telTrackParams)
  }

  async created() {}
}
